import { Link } from "react-router-dom";
import { UtensilsCrossed } from "lucide-react";
import { cn } from "@/lib/utils";

// Reusable "Découvrir la carte" CTA linking to the dedicated menus page.
export function MenuButton({
  children = "Découvrir la carte",
  variant = "outline",
  className,
  testId = "menu-cta",
  withIcon = true,
}) {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-7 py-3 text-sm font-medium tracking-wide transition-[background-color,color,transform,box-shadow] duration-300 hover:-translate-y-0.5";
  const variants = {
    primary: "bg-[#2C2C2C] text-white hover:bg-[#C9A84C] hover:text-[#2C2C2C] shadow-sm",
    gold: "bg-[#C9A84C] text-[#2C2C2C] hover:bg-[#2C2C2C] hover:text-white",
    outline: "border border-[#2C2C2C] text-[#2C2C2C] hover:bg-[#2C2C2C] hover:text-white",
    light: "border border-white/70 text-white hover:bg-white hover:text-[#2C2C2C]",
  };
  return (
    <Link to="/menus" data-testid={testId} className={cn(base, variants[variant], className)}>
      {withIcon && <UtensilsCrossed size={16} />} {children}
    </Link>
  );
}
